import React, { useEffect, useState } from 'react';
import {
  Columns,
  Column,
  Card,
  SubTitle,
  Button,
  Form,
} from '@codeparva/ui-components-library';
import { JumbotronTypes } from '../../jumbotronTypes';
// import { Price } from './cardHelper/Price';
import { CTA } from './cardHelper/CTA';
import { weakKey } from '../../../../../../utilities/weakKey';
import { Rating } from '../../../../../sitewide/components/locationMap/components/Rating';
import { FontAwesomeIcon } from '../../../../../../utilities/iconLoader/FontAwesomeIcon';
import { CardFormattedHrs } from './cardHelper/CardFormattedHrs';
import Accordion from '../accordion/Accordion';
import { useWindowDimensions } from '../../../../../../utilities/Dimensions';

const DefaultTheme: JumbotronTypes.TColorTheme = {
  selectCardLabel: 'primary',
};

export const CardDropdown = ({
  contactDetails,
  cardDropDown,
  theme = DefaultTheme,
  variant,
  accordion,
}: JumbotronTypes.ICard) => {
  const { Select } = Form;

  const { width } = useWindowDimensions();

  const [selectedValue, setSelectedValue] = useState('');
  const [selectIndex, setSelectIndex] = useState(0);

  useEffect(() => {
    if (contactDetails && contactDetails?.length > 0) {
      const value = contactDetails?.[0].locationName
        ? contactDetails?.[0].locationName
        : '';
      setSelectedValue(value);
      setSelectIndex(0);
    }
  }, []);

  const onChange = (e: any) => {
    const { value } = e.target as HTMLInputElement;
    setSelectedValue(value);
    const index = contactDetails?.findIndex(x => {
      if (x.locationName === value) {
        return true;
      }
    });
    if (index !== undefined) {
      setSelectIndex(index);
    }
  };

  const setRating = (contact: JumbotronTypes.TContactDetails) => {
    if (contact) {
      const {
        rating,
        totalReviews,
        fillColor,
        maxRating,
        size,
      } = contact.reviewRating;
      if (rating && totalReviews) {
        return (
          <>
            <Rating
              rating={rating}
              totalReviews={totalReviews}
              fillColor={fillColor}
              maxRating={maxRating}
              size={size}
            />
          </>
        );
      }
    }
  };

  const renderFaciliityHours = (contact: JumbotronTypes.TContactDetails) => {
    const { facilityHours } = contact;
    return (
      <>
        {accordion && Object.keys(facilityHours).length >= 2 ? (
          width <= 768 ? (
            <CardFormattedHrs />
          ) : (
            <Accordion
              title={accordion?.title}
              content={<CardFormattedHrs />}
              closeIcon={accordion?.closeIcon}
              openIcon={accordion?.openIcon}
              variant={variant}
            />
          )
        ) : (
          <CardFormattedHrs />
        )}
      </>
    );
  };
  return (
    <Columns>
      <Column>
        <Card className="selectCard">
          <Card.Content>
            <Columns className="is-mobile">
              <Column>
                <p className="is-size-4">
                  <strong>{cardDropDown?.header.data}</strong>
                </p>
              </Column>
              <Column size="one-fifth">
                <FontAwesomeIcon
                  iconClassName={cardDropDown?.header.icon.iconClassName!}
                  iconContextProps={{
                    className: `${`has-text-${cardDropDown?.header.icon.color ||
                      'primary'}`}`,
                    style: {
                      fontSize: cardDropDown?.header.icon.size || 41,
                    },
                  }}
                />
              </Column>
            </Columns>
            <Columns>
              <Column>
                <fieldset className="selectCardLabel">
                  <legend className={`has-text-${theme.selectCardLabel}`}>
                    {cardDropDown?.cardInputLabel}
                  </legend>
                  <Select
                    value={selectedValue}
                    onChange={onChange}
                    tabIndex={selectIndex}
                  >
                    <select className={`has-text-${theme.selectCardLabel}`}>
                      {contactDetails?.map(contactDetail => (
                        <option
                          key={weakKey(contactDetail)}
                          value={`${contactDetail?.locationName}`}
                          className={`has-text-${theme.selectCardLabel}`}
                        >
                          {`${contactDetail?.locationName}`}
                        </option>
                      ))}
                    </select>
                  </Select>
                </fieldset>
              </Column>
            </Columns>
            <Columns>
              {contactDetails?.[selectIndex].address?.map(address => (
                <Column className="DDCardAddress" key={weakKey(address)}>
                  <a
                    href={address?.link}
                    className="is-flex  yarn  is-align-items-center"
                    target="_blank"
                  >
                    <FontAwesomeIcon
                      iconClassName={address?.icon?.iconClassName!}
                      iconContextProps={{
                        className: `${`has-text-${address?.icon?.color}`}`,
                        style: {
                          fontSize: address?.icon?.size || 28,
                        },
                      }}
                    />
                    <SubTitle className="ml-2" size="6">
                      {address.data}
                    </SubTitle>
                  </a>
                </Column>
              ))}
            </Columns>
            <Columns>
              <Column className="is-flex  is-align-items-center is-flex-direction-row-reverse">
                <>
                  <span className="ml-1 has-text-weight-bold rating">
                    Rating
                  </span>
                  {contactDetails && setRating(contactDetails[selectIndex])}
                </>
              </Column>
            </Columns>
            <Columns>
              {contactDetails?.[selectIndex]?.reviewLink && (
                <Column className="has-text-right">
                  <Button
                    isLink={true}
                    size="auto"
                    href={contactDetails?.[selectIndex]?.reviewLink?.link}
                    outlined={true}
                    color={contactDetails?.[selectIndex]?.reviewLink?.color}
                  >
                    {contactDetails?.[selectIndex]?.reviewLink?.text}
                  </Button>
                </Column>
              )}
            </Columns>
            <Columns>
              <Column className="has-text-center">
                {renderFaciliityHours(contactDetails![selectIndex])}
              </Column>
            </Columns>
            <Columns className="is-mobile is-flex-wrap-nowrap">
              <Column narrow={true}>
                <CTA
                  buttonText={contactDetails?.[selectIndex].buttonText}
                  variant={variant}
                />
              </Column>
              {contactDetails?.[selectIndex]?.contactNumber?.map(
                contactNumber => (
                  <Column narrow={true} key={weakKey(contactNumber)}>
                    <a href={contactNumber?.link}>
                      <FontAwesomeIcon
                        iconClassName={contactNumber?.icon?.iconClassName!}
                        iconContextProps={{
                          className: `${`has-text-${contactNumber?.icon?.color}`}`,
                          style: {
                            fontSize: contactNumber?.icon?.size || 38,
                          },
                        }}
                      />
                    </a>
                  </Column>
                )
              )}
            </Columns>
            <Columns>
              <Column>
                {/* <Price
                  priceSection={contactDetails![selectIndex].priceSection}
                  variant={variant}
                /> */}
              </Column>
            </Columns>
          </Card.Content>
        </Card>
      </Column>
    </Columns>
  );
};
